<template>
    <q-page class="q-pa-md" style="height: 100%; overflow-y: auto;">
        <q-dialog v-model="dialogConfirmacion" persistent>
            <q-card v-if="documentoEliminar != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Deseas eliminar el documento
                                <strong>{{ documentoEliminar.nombreDoc }}</strong> permanentemente.?</span>
                        </div>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="UpdateDocumento()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogPdf" persistent>
            <q-card style="width: 1100px; max-width: 80vw;">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Documento</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section style="max-height: 70vh" class="scroll">
                    <div class="text-center">
                        <q-btn icon="download" flat label="Descargar documento" color="primary" @click="descargarPDF" />
                    </div>
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-borders" v-model="dialogDocumento" persistent>
            <q-card style="width: 600px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Nuevo Documento</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section class="row items-center q-pb-none q-col-gutter-md ">
                    <div class="col-12 col-md-12">
                        <q-select outlined v-model="documento.tipo" :options="listaTipos" label="Tipo"
                            option-label="nombre" option-value="nombre" dense emit-value map-options>
                        </q-select>
                    </div>
                    <div class="col-12 ">
                        <q-input v-model="documento.descripcion" outlined label="Descripción" dense required />
                    </div>

                    <div class="col-12 col-md-12">
                        <q-file v-model="archivoSeleccionado" dense outlined label="Subir Documento PDF"
                            class="full-width" accept=".pdf,application/pdf">
                        </q-file>
                    </div>
                </q-card-section>
                <q-card-actions>
                    <q-btn class="full-width" flat color="primary" icon="save" @click="PostDocumento()"
                        label="Agregar documento" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-card class="q-pa-md q-mt-md">
            <q-card-section>
                <div class="row">
                    <div class="col-12">
                        <div class="text-h6 text-primary">Expedientes de Vehiculo</div>
                        <div class="text-subtitle2 text-grey">Aquí podrás gestionar la documentacíon de sus vehiculos
                        </div>
                    </div>
                    <div class="col-12 row no-wrap justify-end q-mt-md">
                        <q-select outlined v-model="selectAuto" :options="listaCarros" style="width: 100%;"
                            class="q-ma-none q-pa-none q-mr-sm" label="Vehículo" option-label="texto" option-value="id"
                            dense emit-value map-options>
                            <template v-slot:option="scope">
                                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-car" color="priamry" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>{{ scope.opt.marca }} {{ scope.opt.modelo }} ({{ scope.opt.anio
                                            }})</q-item-label>
                                        <q-item-label caption>Placa: {{ scope.opt.placa }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </template>
                        </q-select>
                        <q-btn color="primary" style="width: 250px;" icon="mdi-magnify" label="CONSULTAR"
                            @click="GetExpedientePorAuto()" class="q-mr-sm" />
                        <q-btn color="primary" style="width: 250px;" icon="mdi-plus" label="Agregar"
                            @click="AgregarDocumento()" />
                    </div>
                </div>
                <div>
                </div>
            </q-card-section>
        </q-card>

        <q-table grid :card-container-class="cardContainerClass" title="Expedientes" :data="expedientes"
            :columns="columns" row-key="_id" :filter="filter" :pagination.sync="pagination"
            :rows-per-page-options="rowsPerPageOptions" :loading="loading">
            <template v-slot:top-right>
                <q-input borderless dense debounce="300" v-model="filter" placeholder="Buscar documento">
                    <template v-slot:append>
                        <q-icon name="search" />
                    </template>
                </q-input>
            </template>

            <template v-slot:item="props">
                <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
                    <q-card>
                        <q-card-section>
                            <div class="text-subtitle1 text-center">
                                <q-icon :name="getIcon(props.row.extencion)" color="primary" size="40px"
                                    class="q-mb-sm" />
                            </div>
                            <div class="text-caption text-center text-grey">
                                {{ props.row.tipo }}
                            </div>
                            <div class=" text-center "><strong>{{ props.row.nombreDoc }}</strong></div>
                            <div class="text-caption text-center text-grey">
                                {{ props.row.descripcion }}
                            </div>
                        </q-card-section>

                        <q-separator />

                        <q-card-section class="text-center">
                            <div class="text-caption">Fecha guardado:</div>
                            <div>{{ props.row.fechaGuardado }}</div>
                        </q-card-section>

                        <q-separator />

                        <q-card-actions align="around">
                            <q-btn flat color="primary" icon="visibility" @click="verDocumento(props.row)"
                                label="Ver" />
                            <q-btn flat color="negative" icon="delete" @click="confirmDeleteDocument(props.row)"
                                label="Eliminar" />
                        </q-card-actions>
                    </q-card>
                </div>
            </template>
        </q-table>
    </q-page>
</template>

<script>

import axios from "axios";
import * as XLSX from 'xlsx'
import moment from 'moment';
import { QSpinnerClock } from 'quasar'
import VisualizadorPDF from "../../PDF/VistasPreviasPDF.vue";

export default {
    components: {
        VisualizadorPDF,
    },
    data() {
        return {
            loading: false,
            filter: '',
            pagination: {
                page: 1,
                rowsPerPage: this.getItemsPerPage()
            },
            columns: [
                { name: 'nombreDoc', label: 'Nombre Documento', field: 'nombreDoc' },
                { name: 'tipo', label: 'Tipo', field: 'tipo' },
                { name: 'fechaGuardado', label: 'Fecha', field: 'fechaGuardado' },
                { name: 'descripcion', label: 'Descripción', field: 'descripcion' },
                { name: 'estatus', label: 'Estatus', field: 'estatus' }
            ],
            expedientes: [],
            listaCarros: [],
            selectAutoConsulta: '',
            dialogDocumento: false,

            documento: {
                _id: '',
                _id_vehiculo: '',
                tipo: '',
                descripcion: '',
                nombreDoc: '',
                fechaGuardado: '',
                ruta: '',
                extencion: '',
                documento: '',
                estatus: ''
            },

            listaTipos: [],
            tipo: '',
            archivoSeleccionado: null,
            selectAuto: null,
            dialogPdf: false,
            nombreDoc: '',
            documentoEliminar: null,
            dialogConfirmacion: false
        }
    },

    created() {
        this.GetAutos();
        this.GetTipos();
    },

    computed: {
        cardContainerClass() {
            if (this.$q.screen.gt.xs) {
                return 'grid-masonry grid-masonry--' + (this.$q.screen.gt.sm ? '3' : '2')
            }
            return void 0
        },
        rowsPerPageOptions() {
            if (this.$q.screen.gt.xs) {
                return this.$q.screen.gt.sm ? [3, 6, 9] : [3, 6]
            }
            return [3]
        }
    },

    watch: {
        '$q.screen.name'() {
            this.pagination.rowsPerPage = this.getItemsPerPage()
        }
    },

    methods: {
        async PostDocumento() {
            try {
                if (this.documento.tipo == '') {
                    this.$q.notify({ type: 'warning', position: 'top-right', message: `Seleccione el tipo de documento que subira a su expediente.` });
                    return
                }

                const archivo = this.archivoSeleccionado;
                if (!archivo) {
                    this.$q.notify({
                        color: 'negative',
                        message: 'Debe cargar el Documero PDF de la poliza.',
                        position: 'top-right'
                    });
                    return;
                }

                const base64 = await this.convertirABase64(archivo);
                let nombre_archivo = archivo.name;
                let archivo64base = base64;

                this.documento._id_vehiculo = this.selectAuto
                this.documento.nombreDoc = nombre_archivo
                this.documento.fechaGuardado = moment().format('YYYY/MM/DD')
                this.documento.estatus = 'Vigente'
                this.documento.documento = archivo64base

            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando documento. Espere...', messageColor: 'white' })

                let respuesta = await axios.post('Autos/PostExpediente', this.documento);
                console.log(respuesta)
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Se guardo el documento al expediente del vehiculo.` });
                this.documento= {
                _id: '',
                _id_vehiculo: '',
                tipo: '',
                descripcion: '',
                nombreDoc: '',
                fechaGuardado: '',
                ruta: '',
                extencion: '',
                documento: '',
                estatus: ''
            }
            this.archivoSeleccionado = null
            } catch (error) {
                console.log(error)
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al guardar el documento.` });

            }
        },

        AgregarDocumento() {
            if (this.selectAuto == null) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el auto.` });
                return
            }
            this.dialogDocumento = true
        },

        async GetTipos() {
            try {
                let respuesa = await axios.get('Autos/GetTiposDocumentos/')
                console.log(respuesa)

                this.listaTipos = respuesa.data

            } catch (error) {
                console.log(error)
            }
        },

        async GetAutos() {
            try {
                let respuesa = await axios.get('Reportes/GetAutosDetalles/')
                console.log(respuesa)

                this.listaCarros = respuesa.data.map(auto => ({
                    ...auto,
                    texto: `${auto.marca} ${auto.modelo} (${auto.anio}) - ${auto.placa}`
                }));

            } catch (error) {
                console.log(error)
            }
        },

        async GetExpedientePorAuto() {
            this.loading = true

            try {
                let respuesa = await axios.get('Autos/GetExpedientePorAuto/' + this.selectAuto)
                console.log(respuesa)

                this.expedientes = respuesa.data
                this.loading = false

            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },

        confirmDeleteDocument(row) {
            this.documentoEliminar = row
            this.dialogConfirmacion = true
        },
        async UpdateDocumento() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando documento. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Autos/UpdateDocumento/', this.documentoEliminar)
                console.log(respuesa)
                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Se elimino corrrectamente el documento.` });
                this.dialogConfirmacion = false
                this.GetExpedientePorAuto()
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al eliminar documento.' });
                console.log(error)
            }
        },


        getItemsPerPage() {
            const { screen } = this.$q
            if (screen.lt.sm) return 3
            if (screen.lt.md) return 6
            return 9
        },

        getIcon(ext) {
            const map = {
                pdf: 'picture_as_pdf',
                jpg: 'image',
                png: 'image',
                doc: 'description',
                docx: 'description',
                xls: 'grid_on',
                xlsx: 'grid_on',
                default: 'insert_drive_file'
            }
            return map.pdf
        },

        async verDocumento(row) {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando documento. Espere...', messageColor: 'white' })

            try {
                let respuesa = await axios.post('Autos/GetDocumento/', row)
                console.log(respuesa)
                this.$q.loading.hide()
                this.$store.state.auth.storeBase64Cotizacion = respuesa.data.extencion + ',' + respuesa.data.documento
                this.nombreDoc = respuesa.data.nombreDoc
                this.dialogPdf = true
            } catch (error) {
                this.$q.loading.hide()

                console.log(error)
            }
        },

        eliminarDocumento(row) {
            this.$q.dialog({
                title: 'Confirmar',
                message: `¿Eliminar el documento "${row.nombreDoc}"?`,
                cancel: true,
                persistent: true
            }).onOk(() => {
                console.log('Eliminando...', row)
                // Aquí harías la llamada a tu API para eliminar
            })
        },
        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        descargarPDF() {
            const fileName = this.nombreDoc;
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },
    },

    mounted() {
        // Aquí puedes cargar tus expedientes desde API
        // Ejemplo simulado:

    }
}
</script>

<style lang="sass">
  .grid-masonry
    flex-direction: column
    height: 700px
  
    &--2
      > div
        &:nth-child(2n + 1)
          order: 1
        &:nth-child(2n)
          order: 2
  
      &:before
        content: ''
        flex: 1 0 100% !important
        width: 0 !important
        order: 1
  
    &--3
      > div
        &:nth-child(3n + 1)
          order: 1
        &:nth-child(3n + 2)
          order: 2
        &:nth-child(3n)
          order: 3
  
      &:before,
      &:after
        content: ''
        flex: 1 0 100% !important
        width: 0 !important
        order: 2
  </style>